(function () {
  function eur(n) { return n.toLocaleString('fr-FR') + ' \u20ac'; }
  function init(root) {
    if (root.dataset.init) return; root.dataset.init = '1';
    var A = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
    var q = function (s) { return root.querySelector(s); };
    var BY = {};
    root.querySelectorAll('.m3d-card').forEach(function (c) {
      BY[c.dataset.nm] = { code: c.dataset.nm, dims: c.dataset.dm, w: parseInt(c.dataset.w, 10) || 0, price: parseFloat(c.dataset.p) || 0, img: c.dataset.img };
    });
    var seq = (A.initial || '').split(/[,;\s]+/).map(function (s) { return s.trim().toUpperCase(); }).filter(function (s) { return BY[s]; });
    var plan = 'hevea', view = 'angle';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ---------- 3D
    var stage = q('.m3d-stage');
    var renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, (window.innerWidth < 700 ? 1.75 : 2)));
    renderer.outputEncoding = THREE.sRGBEncoding; renderer.toneMapping = THREE.NoToneMapping;
    renderer.shadowMap.enabled = true; renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    stage.insertBefore(renderer.domElement, stage.firstChild);
    var scene = new THREE.Scene(); scene.background = new THREE.Color(0xe9e8e5).convertSRGBToLinear();
    var pmrem = new THREE.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
    var camera = new THREE.PerspectiveCamera(38, 1.6, 0.05, 80);
    var controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; controls.dampingFactor = 0.08; controls.maxPolarAngle = Math.PI / 2 - 0.04;
    controls.minDistance = 1.2; controls.maxDistance = 22; controls.screenSpacePanning = true;
    var sun = new THREE.DirectionalLight(0xffffff, 0.55); sun.castShadow = true;
    var small = window.matchMedia && window.matchMedia('(max-width: 990px)').matches; sun.shadow.mapSize.set(small ? 1024 : 2048, small ? 1024 : 2048); sun.shadow.bias = -0.0004; sun.shadow.normalBias = 0.02;
    scene.add(sun); scene.add(sun.target); scene.add(new THREE.HemisphereLight(0xffffff, 0x777777, 0.12));
    var core = window.createStahlCore(THREE, A, function (w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; });
    var current = null, env = null, hl = null, camGoal = null, ready = false, visible = true;

    function envFor(r) {
      var g = new THREE.Group(), L1 = Math.max(r.L1, 1), L2 = Math.max(r.L2, 0);
      var f = new THREE.Mesh(new THREE.PlaneGeometry(40, 40), core.M.floor); f.rotation.x = -Math.PI / 2; f.position.set(L1 / 2, 0, 6); f.receiveShadow = true; g.add(f);
      var w1 = new THREE.Mesh(new THREE.PlaneGeometry(L1 + 6, 3.2), core.M.wall); w1.position.set(L1 / 2 - 1, 1.6, -0.002); w1.receiveShadow = true; g.add(w1);
      if (r.corner) { var w2 = new THREE.Mesh(new THREE.PlaneGeometry(L2 + 5, 3.2), core.M.wall); w2.rotation.y = -Math.PI / 2; w2.position.set(r.Xc + 0.002, 1.6, (L2 + 5) / 2 - 0.2); w2.receiveShadow = true; g.add(w2); }
      return g;
    }
    function frame(r, mode, instant) {
      var box = new THREE.Box3().setFromObject(r.group); if (box.isEmpty()) box.set(new THREE.Vector3(0, 0, 0), new THREE.Vector3(1.5, 2, 0.5));
      var c = box.getCenter(new THREE.Vector3()), s = box.getSize(new THREE.Vector3());
      var dir = mode === 'face' ? new THREE.Vector3(0, 0.12, 1) : (r.corner ? new THREE.Vector3(-0.72, 0.32, 1) : new THREE.Vector3(-0.35, 0.22, 1));
      dir.normalize();
      // cadrage : on recule jusqu'a ce que les 8 coins tiennent dans une zone sure (marge en haut pour les boutons)
      var target = new THREE.Vector3(c.x, c.y * 0.94, c.z), dist = fitDist(box, target, dir);
      var pos = target.clone().addScaledVector(dir, dist);
      sun.position.set(c.x - 2.5, 5.5, c.z + 4.5); sun.target.position.copy(c);
      var sc = sun.shadow.camera, e = Math.max(s.x, s.z) * 0.75 + 1.5; sc.left = -e; sc.right = e; sc.top = e; sc.bottom = -e; sc.near = 0.5; sc.far = 20; sc.updateProjectionMatrix();
      if (instant || reduce) { camera.position.copy(pos); controls.target.copy(target); camGoal = null; controls.update(); }
      else camGoal = { p: pos, t: target, k: 0 };
    }
    function fitDist(box, target, dir) {
      var cam = camera.clone(), pts = [], d = box.getBoundingSphere(new THREE.Sphere()).radius * 2.5;
      [box.min.x, box.max.x].forEach(function (x) { [box.min.y, box.max.y].forEach(function (y) { [box.min.z, box.max.z].forEach(function (z) { pts.push(new THREE.Vector3(x, y, z)); }); }); });
      for (var it = 0; it < 10; it++) {
        cam.position.copy(target).addScaledVector(dir, d); cam.lookAt(target); cam.updateMatrixWorld(); cam.updateProjectionMatrix();
        var f = 0;
        pts.forEach(function (p) { var v = p.clone().project(cam); f = Math.max(f, v.x / 0.9, -v.x / 0.9, v.y / 0.72, -v.y / 0.9); });
        if (Math.abs(f - 1) < 0.01) break;
        d *= f;
      }
      return d;
    }
    function rebuild(instant) {
      if (!ready) return;
      if (current) scene.remove(current.group); if (env) scene.remove(env); clearHL();
      current = core.build(seq, plan); scene.add(current.group); env = envFor(current); scene.add(env);
      frame(current, view, instant);
    }
    function clearHL() { if (hl) { scene.remove(hl); hl = null; } }
    function highlight(i) {
      clearHL(); if (!current) return;
      var p = current.placed.filter(function (x) { return x.idx === i; })[0]; if (!p) return;
      var b = new THREE.Box3().setFromObject(p.obj); b.expandByScalar(0.01);
      hl = new THREE.Box3Helper(b, new THREE.Color(0xb0121a)); scene.add(hl);
    }
    var lastW = 0, lastH = 0;
    function resize() {
      var w = stage.clientWidth; if (!w) return false;
      var vw = window.innerWidth || w, r = vw <= 600 ? 0.85 : (vw <= 990 ? 0.75 : 0.625);
      var h = Math.max(260, Math.min(Math.round(w * r), Math.round((window.innerHeight || 800) * 0.8)));
      if (w === lastW && h === lastH) return false;
      lastW = w; lastH = h;
      stage.style.height = h + 'px'; stage.style.aspectRatio = 'auto';
      var dm = q('.m3d-dims'); if (dm) { if (vw <= 600) { dm.style.left = '12px'; dm.style.right = 'auto'; } else { dm.style.left = ''; dm.style.right = ''; } }
      renderer.setSize(w, h, true); camera.aspect = w / h; camera.updateProjectionMatrix();
      return true;
    }
    new ResizeObserver(function () { if (resize() && current && !camGoal) frame(current, view, true); }).observe(stage);
    window.addEventListener('resize', function () { if (resize() && current && !camGoal) frame(current, view, true); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(stage);
    resize();
    controls.addEventListener('start', function () { camGoal = null; });
    (function loop() {
      requestAnimationFrame(loop);
      if (!visible) return;
      if (camGoal) {
        camGoal.k = Math.min(1, camGoal.k + 0.06);
        camera.position.lerp(camGoal.p, camGoal.k * 0.35); controls.target.lerp(camGoal.t, camGoal.k * 0.35);
        if (camGoal.k >= 1 && camera.position.distanceTo(camGoal.p) < 0.01) camGoal = null;
      }
      controls.update(); renderer.render(scene, camera);
    })();

    // ---------- interface
    var toastT;
    function toast(t) { var el = q('.m3d-toast'); el.textContent = t; el.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('on'); }, 2400); }
    function strip() {
      var ci = seq.indexOf('GZ-010'), h = '';
      seq.forEach(function (c, i) {
        var m = BY[c];
        if (ci >= 0 && i === ci) h += '<span class="m3d-sep">fin mur 1</span>';
        h += '<div class="m3d-item' + (c === 'GZ-010' ? ' is-corner' : '') + '" data-i="' + i + '"><button class="m3d-x" type="button" data-rm="' + i + '" aria-label="Retirer ' + c + '">&times;</button>' +
          (m.img ? '<img alt="" src="' + m.img + '">' : '<div class="m3d-ph"></div>') + '<div class="m3d-nm">' + c + '</div><div class="m3d-w">' + m.w + ' mm</div>' +
          '<div class="m3d-ctr"><button type="button" data-mv="' + i + '" data-d="-1" aria-label="D\u00e9placer ' + c + ' \u00e0 gauche">&#8592;</button><button type="button" data-mv="' + i + '" data-d="1" aria-label="D\u00e9placer ' + c + ' \u00e0 droite">&#8594;</button></div></div>';
        if (ci >= 0 && i === ci) h += '<span class="m3d-sep">d\u00e9but mur 2</span>';
      });
      q('.m3d-strip').innerHTML = h;
      q('.m3d-strip').classList.toggle('empty', seq.length === 0);
    }
    function summary() {
      var n = seq.length, sum = 0, w = 0, ci = seq.indexOf('GZ-010'), w1 = 0, w2 = 0;
      seq.forEach(function (c, i) { sum += BY[c].price; w += BY[c].w; if (ci < 0 || i < ci) w1 += BY[c].w; else if (i > ci) w2 += BY[c].w; });
      if (ci >= 0) { w1 += BY['GZ-010'].w; w2 += BY['GZ-010'].w; }
      q('.m3d-dims').textContent = n ? (ci >= 0 ? 'Mur 1 : ' + w1 + ' mm\u2003Mur 2 : ' + w2 + ' mm' : 'Longueur : ' + w1 + ' mm') : '';
      q('.m3d-tot').textContent = n ? n + ' module' + (n > 1 ? 's' : '') + ' \u00b7 ' + (ci >= 0 ? 'implantation en L' : 'largeur totale ~' + w + ' mm') : 'Aucun module s\u00e9lectionn\u00e9.';
      q('.m3d-price').textContent = n ? 'Prix indicatif : ' + eur(sum) : '';
      var txt = n ? 'MODULES : ' + seq.join('  \u2192  ') + '\n' + (ci >= 0 ? 'IMPLANTATION EN L : mur 1 ~' + w1 + ' mm, mur 2 ~' + w2 + ' mm' : 'LARGEUR TOTALE : ~' + w + ' mm') + '\nOPTIONS : Plan de travail : ' + (plan === 'acier' ? 'Acier' : 'H\u00e9v\u00e9a massif') + '\nPRIX INDICATIF : ' + eur(sum) + ' (TTC)' : '';
      q('.m3d-out').value = txt; var conf = q('.m3d-conf'); if (conf) conf.value = txt;
    }
    function refresh(instant) { strip(); summary(); rebuild(instant); }

    root.querySelectorAll('.m3d-card .m3d-add').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.closest('.m3d-card').dataset.nm;
        if (code === 'GZ-010' && seq.indexOf('GZ-010') >= 0) { toast('Un seul module d\u2019angle par composition pour le moment.'); return; }
        seq.push(code); refresh(); toast(code + ' ajout\u00e9 en fin de composition');
      });
    });
    q('.m3d-strip').addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rm]'), mv = e.target.closest('[data-mv]');
      if (rm) { seq.splice(+rm.getAttribute('data-rm'), 1); refresh(); }
      else if (mv) { var i = +mv.getAttribute('data-mv'), j = i + (+mv.getAttribute('data-d')); if (j < 0 || j >= seq.length) return; var t = seq[i]; seq[i] = seq[j]; seq[j] = t; refresh(); }
    });
    q('.m3d-strip').addEventListener('mouseover', function (e) { var c = e.target.closest('.m3d-item'); if (c) highlight(+c.dataset.i); });
    q('.m3d-strip').addEventListener('mouseleave', clearHL);
    root.querySelectorAll('[data-plan]').forEach(function (b) {
      b.addEventListener('click', function () {
        plan = b.dataset.plan;
        root.querySelectorAll('[data-plan]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (current) core.applyPlan(current.group, plan); summary();
      });
    });
    root.querySelectorAll('[data-view]').forEach(function (b) {
      b.addEventListener('click', function () {
        view = b.dataset.view;
        root.querySelectorAll('[data-view]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        if (current) frame(current, view);
      });
    });
    root.querySelectorAll('.m3d-clear').forEach(function (b) { b.addEventListener('click', function () { if (!seq.length) return; seq = []; refresh(); toast('Composition vid\u00e9e : ajoutez vos modules'); }); });
    var pal = q('.m3d-pal');
    root.querySelectorAll('.m3d-prev,.m3d-next').forEach(function (b) {
      b.addEventListener('click', function () { pal.scrollBy({ left: (b.classList.contains('m3d-prev') ? -1 : 1) * Math.max(280, pal.clientWidth * 0.8), behavior: 'smooth' }); });
    });
    var dl = q('.m3d-dl'); if (dl) dl.addEventListener('click', download);
    function wrap(ctx, text, maxW) {
      var words = text.split(' '), lines = [], cur = '';
      words.forEach(function (w) { var t = cur ? cur + ' ' + w : w; if (ctx.measureText(t).width > maxW && cur) { lines.push(cur); cur = w; } else cur = t; });
      if (cur) lines.push(cur); return lines;
    }
    function download() {
      if (!current || !seq.length) { toast('Ajoutez au moins un module avant de t\u00e9l\u00e9charger.'); return; }
      var W = 1600, H = Math.round(W * lastH / lastW), pr = renderer.getPixelRatio();
      renderer.setPixelRatio(1); renderer.setSize(W, H, false); camera.aspect = W / H; camera.updateProjectionMatrix();
      renderer.render(scene, camera);
      var shot = document.createElement('canvas'); shot.width = W; shot.height = H; shot.getContext('2d').drawImage(renderer.domElement, 0, 0, W, H);
      renderer.setPixelRatio(pr); renderer.setSize(lastW, lastH, true); camera.aspect = lastW / lastH; camera.updateProjectionMatrix();
      var n = seq.length, sum = 0, ci = seq.indexOf('GZ-010'), w1 = 0, w2 = 0, w = 0;
      seq.forEach(function (c, i) { sum += BY[c].price; w += BY[c].w; if (ci < 0 || i < ci) w1 += BY[c].w; else if (i > ci) w2 += BY[c].w; });
      if (ci >= 0) { w1 += BY['GZ-010'].w; w2 += BY['GZ-010'].w; }
      var rows = [
        ['Modules (' + n + ')', seq.join('  \u2192  ')],
        ['Implantation', ci >= 0 ? 'En L : mur 1 ~' + w1 + ' mm, mur 2 ~' + w2 + ' mm' : 'Droite : ~' + w + ' mm'],
        ['Plan de travail', (plan === 'acier' ? 'Acier' : 'H\u00e9v\u00e9a massif') + (seq.indexOf('GZ-008') >= 0 ? ' (inox sur le module \u00e9vier)' : '')],
        ['Prix indicatif', eur(sum) + ' TTC']
      ];
      var out = document.createElement('canvas'), ctx = out.getContext('2d'), pad = 70, head = 130, labW = 330, font = 'Helvetica Neue, Helvetica, Arial, sans-serif';
      ctx.font = '400 34px ' + font;
      var blocks = rows.map(function (r) { return wrap(ctx, r[1], W - pad * 2 - labW); });
      var textH = 70 + blocks.reduce(function (a, b) { return a + b.length * 46 + 22; }, 0) + 110;
      out.width = W; out.height = head + H + textH;
      ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, W, out.height);
      ctx.fillStyle = '#111111'; ctx.fillRect(0, 0, W, head);
      ctx.fillStyle = '#ffffff'; ctx.font = '800 50px ' + font; ctx.textBaseline = 'middle'; ctx.fillText('STAHLEXPERT', pad, head / 2);
      ctx.font = '400 30px ' + font; ctx.textAlign = 'right';
      ctx.fillText('Ma configuration d\u2019atelier \u2014 ' + new Date().toLocaleDateString('fr-FR'), W - pad, head / 2); ctx.textAlign = 'left';
      ctx.drawImage(shot, 0, head);
      var y = head + H + 70; ctx.textBaseline = 'alphabetic';
      rows.forEach(function (r, i) {
        ctx.fillStyle = '#777777'; ctx.font = '700 28px ' + font; ctx.fillText(r[0].toUpperCase(), pad, y);
        ctx.fillStyle = '#111111'; ctx.font = (i === 3 ? '800 40px ' : '400 34px ') + font;
        blocks[i].forEach(function (l, k) { ctx.fillText(l, pad + labW, y + k * 46); });
        y += blocks[i].length * 46 + 22;
      });
      ctx.fillStyle = '#888888'; ctx.font = '400 24px ' + font;
      ctx.fillText('Estimation TTC, hors livraison et installation. Devis personnalis\u00e9 sur stahlexpert.com', pad, out.height - 50);
      out.toBlob(function (blob) {
        var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'ma-configuration-stahlexpert.png';
        document.body.appendChild(a); a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 2000);
        toast('Image de votre configuration t\u00e9l\u00e9charg\u00e9e');
      }, 'image/png');
    }
    var cp = q('.m3d-copy');
    if (cp) cp.addEventListener('click', function () {
      var out = q('.m3d-out'); out.select(); try { document.execCommand('copy'); } catch (e) {}
      if (navigator.clipboard) navigator.clipboard.writeText(out.value);
      cp.textContent = 'Copi\u00e9 !'; setTimeout(function () { cp.textContent = 'Copier ma configuration'; }, 1500);
    });

    strip(); summary();
    core.makeMaterials(null);
    core.loadAll(function (p) { var f = q('.m3d-bar i'); if (f) f.style.width = Math.round(p * 100) + '%'; }).then(function () {
      ready = true; rebuild(true); q('.m3d-load').classList.add('gone');
    });
  }
  function boot() { document.querySelectorAll('.m3d[data-m3d]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
